<!-- Copyright (c) 2020 Bankers Healthcare Group All rights reserved -->

<template>
  <div>
    <div class="landing-nav">
      <div class="landing-cover-image"></div>
      <div v-if="applyNaluRebrand" class="landing-cover-text">Your partner in financing.</div>
      <div v-else class="landing-cover-text">Your partner in <br/>healthcare financing.</div>
      <div class="landing-btn-container">
        <div class="landing-control-item">
            <router-link to="/providers" v-if="applyNaluRebrand" tag="div" class="btn-provider" >Merchant Login<em  class="icon-arrow-right"></em></router-link>
            <router-link to="/providers" v-else tag="div" class="btn-provider" >Provider Login<em class="icon-arrow-right"></em></router-link>
            <p>Offer financing to customers or view existing applications</p>
        </div>
        <div class="landing-control-item">
          <router-link to="/borrowers" tag="div" class="btn-borrower">Borrower Login<em class="icon-arrow-right"></em></router-link>
          <p>View your account summary or make a payment</p>
        </div>
      </div>
      <div class="spacer-90" />
    </div>
    <Banner />
  </div>
</template>

<script>
import Banner from '@/components/Banner.vue';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'Home',
  components: {
    Banner,
  },
  computed: {
    ...mapGetters(['isFeatureFlagEnabled']),
    ...mapState({
      currentFeatures: s => s.FeatureFlagModule.currentFeatures,
    }),
    applyNaluRebrand() {
      return this.isFeatureFlagEnabled(this.currentFeatures.applyNaluRebrand);
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-nav {
  position: relative;
  width: 100%;
  z-index: 998;
  .landing-cover-image {
    top: -109px;
    height: 439px;
  }
  .landing-cover-text {
    max-width: 110rem;
    margin: auto;
    padding: 2rem;
  }
  .landing-btn-container {
    max-width: 110rem;
    margin: auto;
    padding: 2rem;
  }
}
</style>
